module.exports = __webpack_public_path__ + "static/media/amazon-logo.693774fe.png";